export const SET_LOGIN_SESSION = "supportui/SessionLogin/SET_LOGIN_SESSION";
export const SET_SESSION_EXPIRED = "supportui/SessionLogin/SET_SESSION_EXPIRED";
export const LOAD_SESSION = "supportui/SessionLogin/LOAD_SESSION";
